import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
/**
 * Created by Ning Jiang on 5/7/2018.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";
import {WildNudgeReelAttentionView} from "./WildNudgeReelAttentionView";

export class WildNudgeReelAttentionController extends ReelStopPresentationController {

    private _nearWinReels:boolean[];
    private _nearWinBigWinReels:boolean[];
    private _scatterPositions:number[];
    private _gameMode:string;

    private _view:WildNudgeReelAttentionView;

    private _isAttentionPlaying:boolean;
    private _isNearWinSoundPlaying:boolean;

    constructor(index:number) {
        super(index, "ReelStopAttention");

        this._view = new WildNudgeReelAttentionView();
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData):void {
        this._gameMode = data.mode;
        this._nearWinReels = data.nearWinReels != null ? data.nearWinReels : ArrayHelper.initArrayWithValues<boolean>(GameConfig.instance.REELS_NUM, (index:number) => {return false});
        this._nearWinBigWinReels = data.nearWinBigWinReels;
        this._scatterPositions = data.scatterPositions != null ? data.scatterPositions : ArrayHelper.initArrayWithValues<number>(GameConfig.instance.REELS_NUM, () => {return -1});
    }

    public onReelBounce(data:IReelStoppedData):void {
        this.playAttention(data);
        this.playNearWinSound(data);
        this.dispatchCompleteEvent(data.reelId);
    }

    private playAttention(data:IReelStoppedData):void {
        if(this._gameMode === GameMode.FREESPIN) {
            return;
        }

        if(data.quickStop && !this._isAttentionPlaying) {
            return;
        }

        if(data.reelId === 2 && this._nearWinReels[3] && this._scatterPositions[1] > -1 && this._scatterPositions[2] > -1) {
            this._view.playAttention(data.reelId + 1);
            this._isAttentionPlaying = true;
            return;
        }

        if(data.reelId === 3) {
            this._view.stopAttention();
            this._isAttentionPlaying = false;
        }
    }

    private playNearWinSound(data:IReelStoppedData):void {
        if(data.quickStop && !this._isNearWinSoundPlaying) {
            return;
        }

        const nextReelId:number = data.reelId + 1;

        if(!this._isNearWinSoundPlaying && (this._nearWinReels[nextReelId] || this._nearWinBigWinReels[nextReelId])) {
            SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.ATTENTION_EFFECT);
            this._isNearWinSoundPlaying = true;
            return;
        }

        if(this._isNearWinSoundPlaying && !this._nearWinReels[nextReelId] && !this._nearWinBigWinReels[nextReelId]) {
            SlotGame.sound.stopEffect(WildNudgeSoundConfig.instance.ATTENTION_EFFECT);
            this._isNearWinSoundPlaying = false;
        }
    }
}